
import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError as observableThrowError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConfigurationService } from '../core/configuration.service';

@Injectable()
export class UserRoleScreenService {
  private baseApiUrl: string;

  constructor(configurationService: ConfigurationService, private httpClient: HttpClient) {
    this.baseApiUrl = configurationService.BaseApiUrl;
  }

  getUserBranch(id: number,isMaintenance: boolean = false): Observable<any> {
    return this.httpClient.get(this.baseApiUrl + `userbranch/${id}?isMaintenance=${isMaintenance}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  getFilteredScreens(filter: string, pageIndex: number, pageSize: number,
    sortColumn: string, sortAscending: boolean, isMaintenance: boolean = false): Observable<any> {

    const params = {
      filter, pageIndex, pageSize, sortColumn, sortAscending, isMaintenance
    };

    return this.httpClient.post(this.baseApiUrl + 'userbranch/filter', params).pipe(
      map((res: any) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  authorise(id: number): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'userbranch/authorise', id).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  delete(id: number): Observable<any> {
    return this.httpClient.delete(this.baseApiUrl + `userbranch/${id}`).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }

  createUserRoleScreen(value: any): Observable<any> {
    return this.httpClient.post(this.baseApiUrl + 'userbranch', value).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  updateUserRoleScreen(value: any): Observable<any> {
    return this.httpClient.put(this.baseApiUrl + 'userbranch', value).pipe(
      map((res: Response) => res),
      catchError((err: any) => observableThrowError(err.message || 'Server error')));
  }
  getSingleUsers(isMaintenance: boolean = false): Observable<any> {
  return this.httpClient
    .get(this.baseApiUrl + `userbranch/singleusers?isMaintenance=${isMaintenance}`)
    .pipe(
      map((res: Response) => res),
      catchError((err: any) =>
        observableThrowError(err.message || 'Server error')
      )
    );
}
 updateUserBranch(value: any): Observable<any> {
  return this.httpClient
    .post(this.baseApiUrl + 'userbranch/updateuserbranch', value)
    .pipe(
      map((res: any) => res),
      catchError((err: any) =>
        observableThrowError(err.message || 'Server error')
  )
    );
}
}
